var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) {
  if (!REACT_ELEMENT_TYPE) {
    REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7;
  }

  var defaultProps = type && type.defaultProps;
  var childrenLength = arguments.length - 3;

  if (!props && childrenLength !== 0) {
    props = {
      children: void 0
    };
  }

  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = new Array(childrenLength);

    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 3];
    }

    props.children = childArray;
  }

  if (props && defaultProps) {
    for (var propName in defaultProps) {
      if (props[propName] === void 0) {
        props[propName] = defaultProps[propName];
      }
    }
  } else if (!props) {
    props = defaultProps || {};
  }

  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: type,
    key: key === undefined ? null : "" + key,
    ref: null,
    props: props,
    _owner: null
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _wrapRegExp() {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };

  var _super = RegExp.prototype;

  var _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    _groups.set(_this, groups || _groups.get(re));

    return _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  _inherits(BabelRegExp, RegExp);

  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    if (result) result.groups = buildGroups(result, this);
    return result;
  };

  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;

        if (typeof args[args.length - 1] !== "object") {
          args = [].slice.call(args);
          args.push(buildGroups(args, _this));
        }

        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }

  return _wrapRegExp.apply(this, arguments);
}

function _asyncIterator(iterable) {
  var method;

  if (typeof Symbol !== "undefined") {
    if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator];
    if (method == null && Symbol.iterator) method = iterable[Symbol.iterator];
  }

  if (method == null) method = iterable["@@asyncIterator"];
  if (method == null) method = iterable["@@iterator"];
  if (method == null) throw new TypeError("Object is not async iterable");
  return method.call(iterable);
}

function _AwaitValue(value) {
  this.wrapped = value;
}

function _AsyncGenerator(gen) {
  var front, back;

  function send(key, arg) {
    return new Promise(function (resolve, reject) {
      var request = {
        key: key,
        arg: arg,
        resolve: resolve,
        reject: reject,
        next: null
      };

      if (back) {
        back = back.next = request;
      } else {
        front = back = request;
        resume(key, arg);
      }
    });
  }

  function resume(key, arg) {
    try {
      var result = gen[key](arg);
      var value = result.value;
      var wrappedAwait = value instanceof _AwaitValue;
      Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) {
        if (wrappedAwait) {
          resume(key === "return" ? "return" : "next", arg);
          return;
        }

        settle(result.done ? "return" : "normal", arg);
      }, function (err) {
        resume("throw", err);
      });
    } catch (err) {
      settle("throw", err);
    }
  }

  function settle(type, value) {
    switch (type) {
      case "return":
        front.resolve({
          value: value,
          done: true
        });
        break;

      case "throw":
        front.reject(value);
        break;

      default:
        front.resolve({
          value: value,
          done: false
        });
        break;
    }

    front = front.next;

    if (front) {
      resume(front.key, front.arg);
    } else {
      back = null;
    }
  }

  this._invoke = send;

  if (typeof gen.return !== "function") {
    this.return = undefined;
  }
}

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () {
  return this;
};

_AsyncGenerator.prototype.next = function (arg) {
  return this._invoke("next", arg);
};

_AsyncGenerator.prototype.throw = function (arg) {
  return this._invoke("throw", arg);
};

_AsyncGenerator.prototype.return = function (arg) {
  return this._invoke("return", arg);
};

function _wrapAsyncGenerator(fn) {
  return function () {
    return new _AsyncGenerator(fn.apply(this, arguments));
  };
}

function _awaitAsyncGenerator(value) {
  return new _AwaitValue(value);
}

function _asyncGeneratorDelegate(inner, awaitWrap) {
  var iter = {},
      waiting = false;

  function pump(key, value) {
    waiting = true;
    value = new Promise(function (resolve) {
      resolve(inner[key](value));
    });
    return {
      done: false,
      value: awaitWrap(value)
    };
  }

  ;

  iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function () {
    return this;
  };

  iter.next = function (value) {
    if (waiting) {
      waiting = false;
      return value;
    }

    return pump("next", value);
  };

  if (typeof inner.throw === "function") {
    iter.throw = function (value) {
      if (waiting) {
        waiting = false;
        throw value;
      }

      return pump("throw", value);
    };
  }

  if (typeof inner.return === "function") {
    iter.return = function (value) {
      if (waiting) {
        waiting = false;
        return value;
      }

      return pump("return", value);
    };
  }

  return iter;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineEnumerableProperties(obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  if (Object.getOwnPropertySymbols) {
    var objectSymbols = Object.getOwnPropertySymbols(descs);

    for (var i = 0; i < objectSymbols.length; i++) {
      var sym = objectSymbols[i];
      var desc = descs[sym];
      desc.configurable = desc.enumerable = true;
      if ("value" in desc) desc.writable = true;
      Object.defineProperty(obj, sym, desc);
    }
  }

  return obj;
}

function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function set(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set = Reflect.set;
  } else {
    set = function set(target, property, value, receiver) {
      var base = _superPropBase(target, property);

      var desc;

      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }

      desc = Object.getOwnPropertyDescriptor(receiver, property);

      if (desc) {
        if (!desc.writable) {
          return false;
        }

        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        _defineProperty(receiver, property, value);
      }

      return true;
    };
  }

  return set(target, property, value, receiver);
}

function _set(target, property, value, receiver, isStrict) {
  var s = set(target, property, value, receiver || target);

  if (!s && isStrict) {
    throw new Error('failed to set property');
  }

  return value;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _readOnlyError(name) {
  throw new TypeError("\"" + name + "\" is read-only");
}

function _writeOnlyError(name) {
  throw new TypeError("\"" + name + "\" is write-only");
}

function _classNameTDZError(name) {
  throw new Error("Class \"" + name + "\" cannot be referenced in computed property keys.");
}

function _temporalUndefined() {}

function _tdz(name) {
  throw new ReferenceError(name + " is not defined - temporal dead zone");
}

function _temporalRef(val, name) {
  return val === _temporalUndefined ? _tdz(name) : val;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _slicedToArrayLoose(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimitLoose(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _maybeArrayLike(next, arr, i) {
  if (arr && !Array.isArray(arr) && typeof arr.length === "number") {
    var len = arr.length;
    return _arrayLikeToArray(arr, i !== void 0 && i < len ? i : len);
  }

  return next(arr, i);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _iterableToArrayLimitLoose(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];

  for (_i = _i.call(arr), _step; !(_step = _i.next()).done;) {
    _arr.push(_step.value);

    if (i && _arr.length === i) break;
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _skipFirstGeneratorNext(fn) {
  return function () {
    var it = fn.apply(this, arguments);
    it.next();
    return it;
  };
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.');
}

function _initializerDefineProperty(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object.keys(descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object.defineProperty(target, property, desc);
    desc = null;
  }

  return desc;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");

  return _classApplyDescriptorGet(receiver, descriptor);
}

function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");

  _classApplyDescriptorSet(receiver, descriptor, value);

  return value;
}

function _classPrivateFieldDestructureSet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");

  return _classApplyDescriptorDestructureSet(receiver, descriptor);
}

function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }

  return privateMap.get(receiver);
}

function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) {
  _classCheckPrivateStaticAccess(receiver, classConstructor);

  _classCheckPrivateStaticFieldDescriptor(descriptor, "get");

  return _classApplyDescriptorGet(receiver, descriptor);
}

function _classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) {
  _classCheckPrivateStaticAccess(receiver, classConstructor);

  _classCheckPrivateStaticFieldDescriptor(descriptor, "set");

  _classApplyDescriptorSet(receiver, descriptor, value);

  return value;
}

function _classStaticPrivateMethodGet(receiver, classConstructor, method) {
  _classCheckPrivateStaticAccess(receiver, classConstructor);

  return method;
}

function _classStaticPrivateMethodSet() {
  throw new TypeError("attempted to set read only static private field");
}

function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    descriptor.value = value;
  }
}

function _classApplyDescriptorDestructureSet(receiver, descriptor) {
  if (descriptor.set) {
    if (!("__destrObj" in descriptor)) {
      descriptor.__destrObj = {
        set value(v) {
          descriptor.set.call(receiver, v);
        }

      };
    }

    return descriptor.__destrObj;
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }

    return descriptor;
  }
}

function _classStaticPrivateFieldDestructureSet(receiver, classConstructor, descriptor) {
  _classCheckPrivateStaticAccess(receiver, classConstructor);

  _classCheckPrivateStaticFieldDescriptor(descriptor, "set");

  return _classApplyDescriptorDestructureSet(receiver, descriptor);
}

function _classCheckPrivateStaticAccess(receiver, classConstructor) {
  if (receiver !== classConstructor) {
    throw new TypeError("Private static access of wrong provenance");
  }
}

function _classCheckPrivateStaticFieldDescriptor(descriptor, action) {
  if (descriptor === undefined) {
    throw new TypeError("attempted to " + action + " private static field before its declaration");
  }
}

function _decorate(decorators, factory, superClass, mixins) {
  var api = _getDecoratorsApi();

  if (mixins) {
    for (var i = 0; i < mixins.length; i++) {
      api = mixins[i](api);
    }
  }

  var r = factory(function initialize(O) {
    api.initializeInstanceElements(O, decorated.elements);
  }, superClass);
  var decorated = api.decorateClass(_coalesceClassElements(r.d.map(_createElementDescriptor)), decorators);
  api.initializeClassElements(r.F, decorated.elements);
  return api.runClassFinishers(r.F, decorated.finishers);
}

function _getDecoratorsApi() {
  _getDecoratorsApi = function () {
    return api;
  };

  var api = {
    elementsDefinitionOrder: [["method"], ["field"]],
    initializeInstanceElements: function (O, elements) {
      ["method", "field"].forEach(function (kind) {
        elements.forEach(function (element) {
          if (element.kind === kind && element.placement === "own") {
            this.defineClassElement(O, element);
          }
        }, this);
      }, this);
    },
    initializeClassElements: function (F, elements) {
      var proto = F.prototype;
      ["method", "field"].forEach(function (kind) {
        elements.forEach(function (element) {
          var placement = element.placement;

          if (element.kind === kind && (placement === "static" || placement === "prototype")) {
            var receiver = placement === "static" ? F : proto;
            this.defineClassElement(receiver, element);
          }
        }, this);
      }, this);
    },
    defineClassElement: function (receiver, element) {
      var descriptor = element.descriptor;

      if (element.kind === "field") {
        var initializer = element.initializer;
        descriptor = {
          enumerable: descriptor.enumerable,
          writable: descriptor.writable,
          configurable: descriptor.configurable,
          value: initializer === void 0 ? void 0 : initializer.call(receiver)
        };
      }

      Object.defineProperty(receiver, element.key, descriptor);
    },
    decorateClass: function (elements, decorators) {
      var newElements = [];
      var finishers = [];
      var placements = {
        static: [],
        prototype: [],
        own: []
      };
      elements.forEach(function (element) {
        this.addElementPlacement(element, placements);
      }, this);
      elements.forEach(function (element) {
        if (!_hasDecorators(element)) return newElements.push(element);
        var elementFinishersExtras = this.decorateElement(element, placements);
        newElements.push(elementFinishersExtras.element);
        newElements.push.apply(newElements, elementFinishersExtras.extras);
        finishers.push.apply(finishers, elementFinishersExtras.finishers);
      }, this);

      if (!decorators) {
        return {
          elements: newElements,
          finishers: finishers
        };
      }

      var result = this.decorateConstructor(newElements, decorators);
      finishers.push.apply(finishers, result.finishers);
      result.finishers = finishers;
      return result;
    },
    addElementPlacement: function (element, placements, silent) {
      var keys = placements[element.placement];

      if (!silent && keys.indexOf(element.key) !== -1) {
        throw new TypeError("Duplicated element (" + element.key + ")");
      }

      keys.push(element.key);
    },
    decorateElement: function (element, placements) {
      var extras = [];
      var finishers = [];

      for (var decorators = element.decorators, i = decorators.length - 1; i >= 0; i--) {
        var keys = placements[element.placement];
        keys.splice(keys.indexOf(element.key), 1);
        var elementObject = this.fromElementDescriptor(element);
        var elementFinisherExtras = this.toElementFinisherExtras((0, decorators[i])(elementObject) || elementObject);
        element = elementFinisherExtras.element;
        this.addElementPlacement(element, placements);

        if (elementFinisherExtras.finisher) {
          finishers.push(elementFinisherExtras.finisher);
        }

        var newExtras = elementFinisherExtras.extras;

        if (newExtras) {
          for (var j = 0; j < newExtras.length; j++) {
            this.addElementPlacement(newExtras[j], placements);
          }

          extras.push.apply(extras, newExtras);
        }
      }

      return {
        element: element,
        finishers: finishers,
        extras: extras
      };
    },
    decorateConstructor: function (elements, decorators) {
      var finishers = [];

      for (var i = decorators.length - 1; i >= 0; i--) {
        var obj = this.fromClassDescriptor(elements);
        var elementsAndFinisher = this.toClassDescriptor((0, decorators[i])(obj) || obj);

        if (elementsAndFinisher.finisher !== undefined) {
          finishers.push(elementsAndFinisher.finisher);
        }

        if (elementsAndFinisher.elements !== undefined) {
          elements = elementsAndFinisher.elements;

          for (var j = 0; j < elements.length - 1; j++) {
            for (var k = j + 1; k < elements.length; k++) {
              if (elements[j].key === elements[k].key && elements[j].placement === elements[k].placement) {
                throw new TypeError("Duplicated element (" + elements[j].key + ")");
              }
            }
          }
        }
      }

      return {
        elements: elements,
        finishers: finishers
      };
    },
    fromElementDescriptor: function (element) {
      var obj = {
        kind: element.kind,
        key: element.key,
        placement: element.placement,
        descriptor: element.descriptor
      };
      var desc = {
        value: "Descriptor",
        configurable: true
      };
      Object.defineProperty(obj, Symbol.toStringTag, desc);
      if (element.kind === "field") obj.initializer = element.initializer;
      return obj;
    },
    toElementDescriptors: function (elementObjects) {
      if (elementObjects === undefined) return;
      return _toArray(elementObjects).map(function (elementObject) {
        var element = this.toElementDescriptor(elementObject);
        this.disallowProperty(elementObject, "finisher", "An element descriptor");
        this.disallowProperty(elementObject, "extras", "An element descriptor");
        return element;
      }, this);
    },
    toElementDescriptor: function (elementObject) {
      var kind = String(elementObject.kind);

      if (kind !== "method" && kind !== "field") {
        throw new TypeError('An element descriptor\'s .kind property must be either "method" or' + ' "field", but a decorator created an element descriptor with' + ' .kind "' + kind + '"');
      }

      var key = _toPropertyKey(elementObject.key);

      var placement = String(elementObject.placement);

      if (placement !== "static" && placement !== "prototype" && placement !== "own") {
        throw new TypeError('An element descriptor\'s .placement property must be one of "static",' + ' "prototype" or "own", but a decorator created an element descriptor' + ' with .placement "' + placement + '"');
      }

      var descriptor = elementObject.descriptor;
      this.disallowProperty(elementObject, "elements", "An element descriptor");
      var element = {
        kind: kind,
        key: key,
        placement: placement,
        descriptor: Object.assign({}, descriptor)
      };

      if (kind !== "field") {
        this.disallowProperty(elementObject, "initializer", "A method descriptor");
      } else {
        this.disallowProperty(descriptor, "get", "The property descriptor of a field descriptor");
        this.disallowProperty(descriptor, "set", "The property descriptor of a field descriptor");
        this.disallowProperty(descriptor, "value", "The property descriptor of a field descriptor");
        element.initializer = elementObject.initializer;
      }

      return element;
    },
    toElementFinisherExtras: function (elementObject) {
      var element = this.toElementDescriptor(elementObject);

      var finisher = _optionalCallableProperty(elementObject, "finisher");

      var extras = this.toElementDescriptors(elementObject.extras);
      return {
        element: element,
        finisher: finisher,
        extras: extras
      };
    },
    fromClassDescriptor: function (elements) {
      var obj = {
        kind: "class",
        elements: elements.map(this.fromElementDescriptor, this)
      };
      var desc = {
        value: "Descriptor",
        configurable: true
      };
      Object.defineProperty(obj, Symbol.toStringTag, desc);
      return obj;
    },
    toClassDescriptor: function (obj) {
      var kind = String(obj.kind);

      if (kind !== "class") {
        throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator' + ' created a class descriptor with .kind "' + kind + '"');
      }

      this.disallowProperty(obj, "key", "A class descriptor");
      this.disallowProperty(obj, "placement", "A class descriptor");
      this.disallowProperty(obj, "descriptor", "A class descriptor");
      this.disallowProperty(obj, "initializer", "A class descriptor");
      this.disallowProperty(obj, "extras", "A class descriptor");

      var finisher = _optionalCallableProperty(obj, "finisher");

      var elements = this.toElementDescriptors(obj.elements);
      return {
        elements: elements,
        finisher: finisher
      };
    },
    runClassFinishers: function (constructor, finishers) {
      for (var i = 0; i < finishers.length; i++) {
        var newConstructor = (0, finishers[i])(constructor);

        if (newConstructor !== undefined) {
          if (typeof newConstructor !== "function") {
            throw new TypeError("Finishers must return a constructor.");
          }

          constructor = newConstructor;
        }
      }

      return constructor;
    },
    disallowProperty: function (obj, name, objectType) {
      if (obj[name] !== undefined) {
        throw new TypeError(objectType + " can't have a ." + name + " property.");
      }
    }
  };
  return api;
}

function _createElementDescriptor(def) {
  var key = _toPropertyKey(def.key);

  var descriptor;

  if (def.kind === "method") {
    descriptor = {
      value: def.value,
      writable: true,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "get") {
    descriptor = {
      get: def.value,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "set") {
    descriptor = {
      set: def.value,
      configurable: true,
      enumerable: false
    };
  } else if (def.kind === "field") {
    descriptor = {
      configurable: true,
      writable: true,
      enumerable: true
    };
  }

  var element = {
    kind: def.kind === "field" ? "field" : "method",
    key: key,
    placement: def.static ? "static" : def.kind === "field" ? "own" : "prototype",
    descriptor: descriptor
  };
  if (def.decorators) element.decorators = def.decorators;
  if (def.kind === "field") element.initializer = def.value;
  return element;
}

function _coalesceGetterSetter(element, other) {
  if (element.descriptor.get !== undefined) {
    other.descriptor.get = element.descriptor.get;
  } else {
    other.descriptor.set = element.descriptor.set;
  }
}

function _coalesceClassElements(elements) {
  var newElements = [];

  var isSameElement = function (other) {
    return other.kind === "method" && other.key === element.key && other.placement === element.placement;
  };

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    var other;

    if (element.kind === "method" && (other = newElements.find(isSameElement))) {
      if (_isDataDescriptor(element.descriptor) || _isDataDescriptor(other.descriptor)) {
        if (_hasDecorators(element) || _hasDecorators(other)) {
          throw new ReferenceError("Duplicated methods (" + element.key + ") can't be decorated.");
        }

        other.descriptor = element.descriptor;
      } else {
        if (_hasDecorators(element)) {
          if (_hasDecorators(other)) {
            throw new ReferenceError("Decorators can't be placed on different accessors with for " + "the same property (" + element.key + ").");
          }

          other.decorators = element.decorators;
        }

        _coalesceGetterSetter(element, other);
      }
    } else {
      newElements.push(element);
    }
  }

  return newElements;
}

function _hasDecorators(element) {
  return element.decorators && element.decorators.length;
}

function _isDataDescriptor(desc) {
  return desc !== undefined && !(desc.value === undefined && desc.writable === undefined);
}

function _optionalCallableProperty(obj, name) {
  var value = obj[name];

  if (value !== undefined && typeof value !== "function") {
    throw new TypeError("Expected '" + name + "' to be a function");
  }

  return value;
}

function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  return fn;
}

function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);

  privateMap.set(obj, value);
}

function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);

  privateSet.add(obj);
}

function _classPrivateMethodSet() {
  throw new TypeError("attempted to reassign private method");
}

/****************************************************************
 * CODE Engraving Configurator
 ****************************************************************/
var EngravingConfigurator = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EngravingConfigurator, _HTMLElement);

  var _super = _createSuper(EngravingConfigurator);

  function EngravingConfigurator() {
    var _self$engravingElemen, _self$engravingElemen2, _self$engravingElemen3, _self$engravingElemen4, _self$engravingElemen5, _self$engravingElemen6, _assertThisInitialize, _assertThisInitialize2;

    var _this;

    _classCallCheck(this, EngravingConfigurator);

    _this = _super.call(this);

    var self = _assertThisInitialized(_this);

    self.engravingElement = _this.querySelector('[data-engraving-sign-options]');
    self.activeTitle = (_self$engravingElemen = self.engravingElement) === null || _self$engravingElemen === void 0 ? void 0 : _self$engravingElemen.querySelector('[data-engraving-zodiac-title]');
    self.birthstoneTitles = (_self$engravingElemen2 = self.engravingElement) === null || _self$engravingElemen2 === void 0 ? void 0 : _self$engravingElemen2.querySelectorAll('[data-engraving-birthstone-title]');
    self.pendantTitles = (_self$engravingElemen3 = self.engravingElement) === null || _self$engravingElemen3 === void 0 ? void 0 : _self$engravingElemen3.querySelectorAll('[data-engraving-pendant-title]');
    self.typeSwitches = (_self$engravingElemen4 = self.engravingElement) === null || _self$engravingElemen4 === void 0 ? void 0 : _self$engravingElemen4.querySelectorAll('[data-engraving-switch]');
    self.typeContainers = (_self$engravingElemen5 = self.engravingElement) === null || _self$engravingElemen5 === void 0 ? void 0 : _self$engravingElemen5.querySelectorAll('[data-engraving-type]');
    self.engravingInline = ((_self$engravingElemen6 = self.engravingElement) === null || _self$engravingElemen6 === void 0 ? void 0 : _self$engravingElemen6.querySelectorAll('[data-engraving-inline]').length) > 0;
    self.configuratorSlides = document.querySelectorAll('[data-product-engraving-image]');
    self.currentVariant = false;
    _this.variantData = false;
    self.windowInnerWidth = window.innerWidth;
    self.keyupEvent = new Event('keyup');
    var defaultOptions = {
      defaultSize: '15%',
      defaultColor: '#2f2105',
      activeType: 1,
      soldOut: "Sold out",
      skuSoldout: []
    };
    var dataOptions = {};

    if ((_assertThisInitialize = _assertThisInitialized(_this)) !== null && _assertThisInitialize !== void 0 && (_assertThisInitialize2 = _assertThisInitialize.dataset) !== null && _assertThisInitialize2 !== void 0 && _assertThisInitialize2.options) {
      dataOptions = JSON.parse(_this.dataset.options);
    }

    var metaOptions = {};

    if (self.engravingElement) {
      metaOptions = self.engravingElement.dataset.engravingSignOptions;
    }

    self.options = _objectSpread2(_objectSpread2(_objectSpread2({}, defaultOptions), dataOptions), metaOptions);
    self.optionValues = [];
    self.blackListArray = self.options.skuSoldout; // See if we have filters to use

    if (self.typeSwitches && self.typeSwitches.length > 0) {
      var filterCheck = false;
      var currentElem = false;
      self.typeSwitches.forEach(function (elem) {
        if (elem.classList.contains('active')) {
          filterCheck = true;
          currentElem = elem;
        }
      });

      if (filterCheck && currentElem) {
        var _currentElem, _currentElem$dataset;

        // See if we have an active item already
        self.options.activeType = (_currentElem = currentElem) === null || _currentElem === void 0 ? void 0 : (_currentElem$dataset = _currentElem.dataset) === null || _currentElem$dataset === void 0 ? void 0 : _currentElem$dataset.engravingSwitch;
      } else {
        // Otherwise take the first item
        self.options.activeType = self.typeSwitches[0].dataset.engravingSwitch;
      }
    }

    self.init();
    return _this;
  }
  /**
   * Init the product
   *
   * @return void
   * @access public
   */


  _createClass(EngravingConfigurator, [{
    key: "init",
    value: function init() {
      var self = this;
      document.querySelectorAll('[data-engraving-configurator-item]').forEach(function (element) {
        element.addEventListener('change', function (e) {
          var elem = e.target;
          var i = elem.dataset.engravingConfiguratorItem;

          if (elem.dataset.engravingZodiacPreview) {
            self.activeTitle.value = elem.dataset.engravingZodiacPreviewTitle;
            self.optionValues[i] = elem.dataset.engravingZodiacPreview;
          } else if (elem.matches('select')) {
            self.optionValues[i] = elem.options[elem.selectedIndex].value;
          } else {
            self.optionValues[i] = elem.value;
          }

          self.renderPreview();
        });
        element.addEventListener('keyup', function (e) {
          var elem = e.target;
          var i = elem.dataset.engravingConfiguratorItem;

          if (elem.dataset.engravingZodiacPreview) {
            self.activeTitle.value = elem.dataset.engravingZodiacPreviewTitle;
            self.optionValues[i] = elem.dataset.engravingZodiacPreview;
          } else if (elem.matches('select')) {
            self.optionValues[i] = elem.options[elem.selectedIndex].value;
          } else {
            self.optionValues[i] = elem.value;
          }

          self.renderPreview();
        });
      });
      document.querySelectorAll('[data-symbol-item]').forEach(function (element) {
        element.addEventListener('click', function (e) {
          e.preventDefault();
          var target = self.querySelector('[data-symbol-input]');
          var symbol = element.dataset.symbolItem;

          if (target && target.value.length < target.maxLength) {
            var cursorPos = target.selectionStart;
            var v = target.value;
            var textBefore = v.substring(0, cursorPos);
            var textAfter = v.substring(cursorPos, v.length);
            target.value = textBefore + symbol + textAfter;
            target.dispatchEvent(self.keyupEvent);
            target.focus();
          }
        });
      }); // Bind events to a change or click events for SKU values

      document.querySelectorAll('[data-engraving-sku-value]').forEach(function (element) {
        element.addEventListener('change', function (e) {
          self.updateSkuValue();
        });
        element.addEventListener('click', function (e) {
          self.updateSkuValue();
        });
      });
      document.querySelectorAll('[data-engraving-sku-select]').forEach(function (element) {
        setTimeout(function () {
          self.resetEngravingSelect(element);
        }, 100);
        element.addEventListener('change', function (e) {
          self.updateSkuValue();
        });
        element.addEventListener('click', function (e) {
          self.updateSkuValue();
        });
      });
      document.addEventListener('variant-change', function () {
        self.updateSkuValue(true);
      });
      window.addEventListener('resize', function (event) {
        if (window.innerWidth != self.windowInnerWidth) {
          setTimeout(function () {
            self.windowInnerWidth = window.innerWidth;
            self.renderPreview();
          }, 100);
        }
      });

      if (self.typeSwitches) {
        self.typeSwitches.forEach(function (element) {
          element.addEventListener('change', function (e) {
            self.options.activeType = e.target.dataset.engravingSwitch;
            self.renderPreview();
          });
          element.addEventListener('blur', function (e) {
            self.options.activeType = e.target.dataset.engravingSwitch;
            self.renderPreview();
          });
          element.addEventListener('click', function (e) {
            e.preventDefault();
            self.options.activeType = e.target.dataset.engravingSwitch;
            self.renderPreview();
          });
        });
      }

      self.updateSkuValue(true);
      self.renderPreview();
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[data-product-variants-json]').textContent);
      return this.variantData;
    }
  }, {
    key: "updateMasterId",
    value: function updateMasterId() {
      this.getVariantData();
      var activeID = parseInt(document.querySelector('[name="id"]').value);
      this.currentVariant = this.variantData.find(function (variant) {
        return variant.id === activeID;
      });
    }
  }, {
    key: "resetEngravingSelect",
    value: function resetEngravingSelect(element) {
      var defaultOption = element.querySelector('[data-default-option]');

      if (element && defaultOption) {
        element.value = defaultOption.value;
      }
    }
  }, {
    key: "updateSkuValue",
    value: function updateSkuValue() {
      var _this$currentVariant,
          _this2 = this;

      var updateVariant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var self = this;
      this.updateMasterId();
      var target = this.querySelector('[data-engraving-sku-format]');
      var valFormat;

      if (target) {
        valFormat = target.dataset.engravingSkuFormat;
      }

      var currentColor = '';
      var currentColorFull = ''; // Get the current variant and check for the color

      var selectedItems = [].concat(_toConsumableArray(this.querySelectorAll('[data-engraving-sku-value]:checked')), _toConsumableArray(this.querySelectorAll('[data-engraving-sku-select]'))); // Get all items

      var allItems = this.querySelectorAll('[data-engraving-sku-value]'); // Check if we have a SKU value we can work with

      if (this !== null && this !== void 0 && (_this$currentVariant = this.currentVariant) !== null && _this$currentVariant !== void 0 && _this$currentVariant.sku) {
        var currentSku = this.currentVariant.sku.toUpperCase();

        if (currentSku.indexOf('ROSEGOLD') !== -1 || currentSku.indexOf('OLR-') !== -1 || currentSku.indexOf('RCR-') !== -1) {
          currentColor = 'R';
          currentColorFull = 'RoseGold';
        } else if (currentSku.indexOf('GOLD') !== -1 || currentSku.indexOf('OLG-') !== -1 || currentSku.indexOf('RCG-') !== -1 || currentSku.indexOf('RFACG-') !== -1) {
          currentColor = 'G';
          currentColorFull = 'Gold';
        } else if (currentSku.indexOf('SILVER') !== -1 || currentSku.indexOf('OLS-') !== -1 || currentSku.indexOf('RCS-') !== -1 || currentSku.indexOf('RFACS-') !== -1) {
          currentColor = 'S';
          currentColorFull = 'Silver';
        }
      } // Check if specific charms or hangers are sold out


      if (updateVariant && self.blackListArray.length > 0) {
        allItems.forEach(function (elem) {
          var fullSku = 'CH-' + currentColorFull + '-' + elem.dataset.engravingSkuValue;

          if (valFormat && valFormat.indexOf('[COLOR') >= 0) {
            if (self.pendantTitles && self.pendantTitles.length > 0 && !self.engravingInline) {
              fullSku = 'PE-' + currentColorFull + '-' + elem.dataset.engravingSkuValue;
            }
          } // remove all disabled properties


          elem.disabled = false;
          var currentText = elem.innerHTML;
          var soldOutText = ' (' + self.options.soldOut + ')';
          var newText = currentText.replace(soldOutText, '');
          var resetParent = false;
          var dataSkuFormat = elem.dataset.skuFormat || false; // Build up the value of the SKU

          if (dataSkuFormat) {
            var skuValue = elem.dataset.engravingSkuValue;
            dataSkuFormat = dataSkuFormat.replace('[SKUVALUE]', skuValue).toLowerCase();
          }

          if (self.blackListArray.includes(fullSku.toLowerCase()) || self.blackListArray.includes(dataSkuFormat)) {
            elem.disabled = true;
            newText += soldOutText; // In case of a select, only reset when the current selected value is sold out

            if (_this2.matches('option')) {
              resetParent = true;
            } else {
              resetParent = true;
              elem.checked = false;
            }
          } // Update the text in this item


          if (elem.matches('option')) {
            elem.innerHTML = newText;
          }

          if (resetParent) {
            if (elem.closest('select')) {
              elem.closest('select').selectedIndex = 0;
            } // Also clear the value from the form input to be sure


            if (target) {
              target.value = '';
            }
          }
        });
      } // Get the current variant and check for the color


      selectedItems.forEach(function (elem) {
        var _this2$currentVariant;

        var skuVal = '';

        if (elem.matches('select')) {
          skuVal = elem.options[elem.selectedIndex].dataset.engravingSkuValue;
        } else {
          skuVal = elem.dataset.engravingSkuValue;
        }

        var selectedParent = elem.parentNode;
        var selectedTarget = selectedParent.querySelector('[data-engraving-sku-format]'); // Check if we have a SKU value we can work with

        if (_this2 !== null && _this2 !== void 0 && (_this2$currentVariant = _this2.currentVariant) !== null && _this2$currentVariant !== void 0 && _this2$currentVariant.sku) {
          if (selectedTarget) {
            var _valFormat = selectedTarget.dataset.engravingSkuFormat; // See if we have custom formatting for this specific item

            if (elem.matches('select') && elem.options[elem.selectedIndex].dataset.skuFormat) {
              _valFormat = elem.options[elem.selectedIndex].dataset.skuFormat;
            } // Build up the SKU for the charm


            _valFormat = _valFormat.replace('[COLOR]', currentColor).replace('[COLORFULL]', currentColorFull).replace('[SKUVALUE]', skuVal);
            selectedTarget.value = _valFormat;
          }
        }
      });
      self.renderPreview(currentColorFull);
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _this3 = this;

      var self = this;
      var i = 1;
      var itemStyle,
          currentColor = '',
          currentColorFull = '',
          fontColor,
          fontSize,
          slideHeight,
          transforms = []; // Render the right zodiac signs and containers

      if (self.typeSwitches && self.typeSwitches.length > 0) {
        self.typeSwitches.forEach(function (elem) {
          var _elem$dataset;

          elem.classList.remove('active');

          if (((_elem$dataset = elem.dataset) === null || _elem$dataset === void 0 ? void 0 : _elem$dataset.engravingSwitch) == self.options.activeType) {
            elem.classList.add('active');
          }
        });
        self.typeContainers.forEach(function (elem) {
          var _elem$dataset2;

          elem.style.display = 'none';

          if (((_elem$dataset2 = elem.dataset) === null || _elem$dataset2 === void 0 ? void 0 : _elem$dataset2.engravingType) == self.options.activeType) {
            elem.style.display = 'block';
          }
        });
      } // Remove any possible content preview in there


      document.querySelectorAll('.engraving-configurator-preview').forEach(function (elem) {
        elem.remove();
      });

      var _loop = function _loop() {
        // Build up the styles from the metafield values
        // Set the default values, they will be overwritten if a metafield exists
        var itemStyle = '';
        var fontSize = parseFloat(self.options.defaultSize.replace('%', '')) / 100;
        var fontColor = self.options.defaultColor;
        var transforms = ['translateX(-50%)', 'translateY(-50%)'];
        var slideHeight = 0;

        if ('engravingConfiguratorOption' + i + 'Left' in self.dataset) {
          itemStyle += 'left: ' + self.dataset['engravingConfiguratorOption' + i + 'Left'].replace(',', '.') + ';';
        }

        if ('engravingConfiguratorOption' + i + 'Top' in self.dataset) {
          itemStyle += 'top: ' + self.dataset['engravingConfiguratorOption' + i + 'Top'].replace(',', '.') + ';';
        }

        if ('engravingConfiguratorOption' + i + 'Style' in self.dataset) {
          itemStyle += 'font-style: ' + self.dataset['engravingConfiguratorOption' + i + 'Style'] + ';';
        }

        if ('engravingConfiguratorOption' + i + 'Rotate' in self.dataset) {
          transforms.push('rotate(' + self.dataset['engravingConfiguratorOption' + i + 'Rotate'] + ')');
        }

        if ('engravingConfiguratorOption' + i + 'Size' in self.dataset) {
          fontSize = parseFloat(self.dataset['engravingConfiguratorOption' + i + 'Size'].replace('%', '') / 100);
        }

        if ('engravingConfiguratorOption' + i + 'Color' in self.dataset) {
          fontColor = self.dataset['engravingConfiguratorOption' + i + 'Color'];
        }

        self.configuratorSlides.forEach(function (elem) {
          elem.querySelectorAll('figure').forEach(function (fig) {
            if (fig.offsetHeight > slideHeight) {
              slideHeight = fig.offsetHeight;
            }
          });
        });
        var calcSize = slideHeight * fontSize; // Complete the style string to supply this preview

        itemStyle += 'color: ' + fontColor + ';';
        itemStyle += 'font-size: ' + Math.round(calcSize) + 'px;';
        itemStyle += 'transform: ' + transforms.join(' ') + ';'; // Check if we are in a zodiac configurator

        var extraClass = '';

        if (self.engravingElement) {
          extraClass = 'zodiac';
        } // Check if we are previewing birthstones or pendants


        var optionValue = '';

        if (self.birthstoneTitles && self.birthstoneTitles.length > 0 || self.pendantTitles && self.pendantTitles.length > 0) {
          var _this3$currentVariant;

          var checkedInput;
          itemStyle += 'height: ' + Math.round(calcSize) + 'px;'; // Check if we have a SKU value we can work with

          if (_this3 !== null && _this3 !== void 0 && (_this3$currentVariant = _this3.currentVariant) !== null && _this3$currentVariant !== void 0 && _this3$currentVariant.sku) {
            var currentSku = _this3.currentVariant.sku.toUpperCase();

            if (currentSku.indexOf('ROSEGOLD') !== -1 || currentSku.indexOf('OLR-') !== -1 || currentSku.indexOf('RCR-') !== -1) {
              currentColor = 'R';
              currentColorFull = 'RoseGold';
            } else if (currentSku.indexOf('GOLD') !== -1 || currentSku.indexOf('OLG-') !== -1 || currentSku.indexOf('RCG-') !== -1 || currentSku.indexOf('RFACG-') !== -1) {
              currentColor = 'G';
              currentColorFull = 'Gold';
            } else if (currentSku.indexOf('SILVER') !== -1 || currentSku.indexOf('OLS-') !== -1 || currentSku.indexOf('RCS-') !== -1 || currentSku.indexOf('RFACS-') !== -1) {
              currentColor = 'S';
              currentColorFull = 'Silver';
            }
          } // Check if options are for birthstones or pendants


          if (self.birthstoneTitles && self.birthstoneTitles.length > 0) {
            extraClass = 'birthstone';
            checkedInput = document.querySelector('[data-birthstone-number-' + i + ']:checked');

            if (checkedInput) {
              var checkedLabel = checkedInput.parentNode.querySelector('label[for=' + checkedInput.id + ']');
              var image = checkedLabel.querySelector('img');
              optionValue = image.outerHTML;
            }
          } else {
            var _selectedOption$datas;

            extraClass = 'pendant';
            var pendantSelect = document.querySelector('[data-pendant-number-' + i + ']');
            var selectedOption = pendantSelect.options[pendantSelect.selectedIndex];
            var previewImagesContainer = document.querySelector('[data-pendant-preview-images]');
            var selectedPreviewContainer = previewImagesContainer.querySelector('[data-pendant-preview="' + ((_selectedOption$datas = selectedOption.dataset) === null || _selectedOption$datas === void 0 ? void 0 : _selectedOption$datas.imageId) + '"]');
            var currentColorLowercase = '';

            if (typeof currentColorFull !== 'undefined') {
              currentColorLowercase = currentColorFull.toLowerCase();
            } else {
              console.log('Color match not found in variant SKU');
              return {
                v: void 0
              };
            }

            if (selectedPreviewContainer && currentColorLowercase !== '') {
              var previewImage = selectedPreviewContainer.querySelector('[data-pendant-color="' + currentColorLowercase + '"]');

              if (previewImage) {
                optionValue = previewImage.outerHTML;
              } else {
                console.log('Preview image not found');
              }
            }
          }
        } else {
          if (self.optionValues[i]) {
            for (var j = 0; j < self.optionValues[i].length; j++) {
              var char = self.optionValues[i][j];

              if (self.checkASCII(char)) {
                optionValue += char;
              } else {
                optionValue += '<span class="special">' + char + '</span>';
              }
            }
          }
        } // Add the preview box to all related slides


        self.configuratorSlides.forEach(function (elem) {
          elem.querySelector('figure').innerHTML += '<div class="engraving-configurator-preview ' + extraClass + '" style="' + itemStyle + '">' + optionValue + '</div>';
        });
        i++;
      };

      while (self.hasAttribute('data-engraving-configurator-option' + i)) {
        var _ret = _loop();

        if (_typeof(_ret) === "object") return _ret.v;
      }
    }
  }, {
    key: "checkASCII",
    value: function checkASCII(str) {
      return str.charCodeAt(0) < 169;
    }
  }]);

  return EngravingConfigurator;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('engraving-configurator')) {
  customElements.define('engraving-configurator', EngravingConfigurator);
}
